exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".uploader{position:relative;overflow:hidden;width:300px;height:250px;background-color:#f3f3f3;background-size:contain;background-position:50%;background-repeat:no-repeat;border:2px dashed #e8e8e8;display:inline-block}.enabled .uploader.hovering{background-color:#bbb}.photo-upload-clear{position:absolute;z-index:4;top:10px;right:10px}.enabled .uploader:hover{background-color:skyblue}.upload-instructions{position:absolute;top:50%;left:50%;-webkit-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%);text-align:center}.file-photo{position:absolute;width:300px;height:400px;top:-50px;left:0;z-index:2;opacity:0}.enabled .file-photo{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bdcc74d2","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/ui/PhotoUpload.vue
// module id = o77N
// module chunks = 0 1 2